export default "__VITE_ASSET__5e11aaac__"